import { render, staticRenderFns } from "./RaddarChart.vue?vue&type=template&id=596d5cba"
import script from "./RaddarChart.vue?vue&type=script&lang=js"
export * from "./RaddarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('596d5cba')) {
      api.createRecord('596d5cba', component.options)
    } else {
      api.reload('596d5cba', component.options)
    }
    module.hot.accept("./RaddarChart.vue?vue&type=template&id=596d5cba", function () {
      api.rerender('596d5cba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/RaddarChart.vue"
export default component.exports